import SNSW002X16EU from './SNSW-002X16EU.js';
import S3GW1DBT001 from './S3GW-1DBT001.js';
import S3DM0A101WWL from './S3DM-0A101WWL.js';
import S3SN0024X from './S3SN-0024X.js';
import S4SN0031Z from './S4SN-0031Z.js';
import S4SN1031Z from './S4SN-1031Z.js';
import SNSL0A2X03WWL from './SNSL-0A2X03WWL.js';
import SNSN0031Z from './SNSN-0031Z.js';
import SNDM9995WW from './SNDM-9995WW.js';
import SNDM00100WW from './SNDM-00100WW.js';
import S3EM003CXCEU63 from './S3EM-003CXCEU63.js';
import S3PM001PCEU16 from './S3PM-001PCEU16.js';
import S3DM0010WW from './S3DM-0010WW.js';
import SPCC001PE10EU from './SPCC-001PE10EU.js';
import S3BLD010009AEU from './S3BL-D010009AEU.js';
import S3SN1U12A from './S3SN-1U12A.js';
import S3SN0U12A from './S3SN-0U12A.js';
import S3SW001P8EU from './S3SW-001P8EU.js';
import S3SW001X8EU from './S3SW-001X8EU.js';
import S3GW1DZW0EU from './S3GW-1DZW0EU.js';
import S3PL10112EU from './S3PL-10112EU.js';
import S3PL00112EU from './S3PL-00112EU.js';
import S3PL20112EU from './S3PL-20112EU.js';
import S3PL30116EU from './S3PL-30116EU.js';
import S3SW001X16EU from './S3SW-001X16EU.js';
import S3SW001P16EU from './S3SW-001P16EU.js';
import S3SN0D24X from './S3SN-0D24X.js';
import S3DM0A1WW from './S3DM-0A1WW.js';
import S3EM002CXCEU from './S3EM-002CXCEU.js';
import S3SW002P16EU from './S3SW-002P16EU.js';
import S3PBO3AR000001 from './S3PB-O3AR000001.js';
import S3GW0D4G0EU from './S3GW-0D4G0EU.js';
import S3SW0A2X4EUL from './S3SW-0A2X4EUL.js';
import S3SW001P16SP from './S3SW-001P16SP.js';
import S3PB04F7045601 from './S3PB-04F7045601.js';
import S3PB0709114901 from './S3PB-0709114901.js';
import S3SH0A2P4EU from './S3SH-0A2P4EU.js';
import S3SW0A1X1EUL from './S3SW-0A1X1EUL.js';
import S3SN0U53X from './S3SN-0U53X.js';
import S3PL30110EU from './S3PL-30110EU.js';
import S3PL00110CN from './S3PL-00110CN.js';
import S3PL00115US from './S3PL-00115US.js';
import S3SN0082A from './S3SN-0082A.js';
import S3PB0A15194101 from './S3PB-0A15194101.js';

export const Gen3 = {
	'SNSW-002X16EU': SNSW002X16EU,
	'S3GW-1DBT001': S3GW1DBT001,
	'S3DM-0A101WWL': S3DM0A101WWL,
	'S3SN-0024X': S3SN0024X,
	'S4SN-0031Z': S4SN0031Z,
	'S4SN-1031Z': S4SN1031Z,
	'SNSL-0A2X03WWL': SNSL0A2X03WWL,
	'SNSN-0031Z': SNSN0031Z,
	'SNDM-9995WW': SNDM9995WW,
	'SNDM-00100WW': SNDM00100WW,
	'S3EM-003CXCEU63': S3EM003CXCEU63,
	'S3PM-001PCEU16': S3PM001PCEU16,
	'S3DM-0010WW': S3DM0010WW,
	'SPCC-001PE10EU': SPCC001PE10EU,
	'S3BL-D010009AEU': S3BLD010009AEU,
	'S3PB-04F7045601': S3PB04F7045601,
	'S3PB-0709114901': S3PB0709114901,
	'S3PB-0A15194101': S3PB0A15194101,
	'S3SN-1U12A': S3SN1U12A,
	'S3SN-0U12A': S3SN0U12A,
	'S3SW-001P8EU': S3SW001P8EU,
	'S3SW-001X8EU': S3SW001X8EU,
	'S3GW-1DZW0EU': S3GW1DZW0EU,
	'S3PL-10112EU': S3PL10112EU,
	'S3PL-00112EU': S3PL00112EU,
	'S3PL-20112EU': S3PL20112EU,
	'S3PL-30110EU': S3PL30110EU,
	'S3PL-30116EU': S3PL30116EU,
	'S3SW-001X16EU': S3SW001X16EU,
	'S3SW-001P16EU': S3SW001P16EU,
	'S3SN-0D24X': S3SN0D24X,
	'S3DM-0A1WW': S3DM0A1WW,
	'S3EM-002CXCEU': S3EM002CXCEU,
	'S3SW-002P16EU': S3SW002P16EU,
	'S3PB-O3AR000001': S3PBO3AR000001,
	'S3GW-0D4G0EU': S3GW0D4G0EU,
	'S3SW-0A2X4EUL': S3SW0A2X4EUL,
	'S3SW-001P16SP': S3SW001P16SP,
	'S3SH-0A2P4EU': S3SH0A2P4EU,
	'S3SW-0A1X1EUL': S3SW0A1X1EUL,
	'S3SN-0U53X': S3SN0U53X,
	'S3PL-00110CN': S3PL00110CN,
	'S3PL-00115US': S3PL00115US,
	'S3SN-0082A': S3SN0082A,
};
